export default "__VITE_ASSET__DRN$Ti8h__"